import {
  ExperienceDto,
  ExperienceListDto,
  ExperienceTestType,
} from "@intelligems/ig-types";

export const isSelectedTestTypeNotCreated = (
  experiences: ExperienceListDto[],
  campaigns: ExperienceListDto[],
  selectedTestType: ExperienceTestType
): boolean => {
  switch (selectedTestType) {
    case "campaign":
      return (
        campaigns.length === 0 &&
        experiences.filter((exp) => exp.testTypes.hasTestCampaign).length === 0
      );
    case "pricing":
      return (
        experiences.filter((exp) => exp.testTypes.hasTestPricing).length === 0
      );
    case "shipping":
      return (
        experiences.filter((exp) => exp.testTypes.hasTestShipping).length === 0
      );
    case "content":
      return (
        experiences.filter((exp) => exp.testTypes.hasTestContent).length === 0
      );
    default:
      return false;
  }
};

export const filterByTestType = (
  experiencesList: ExperienceListDto[],
  selectedTestType: ExperienceTestType
) => {
  return experiencesList.filter((exp) =>
    selectedTestType === "campaign"
      ? exp.testTypes.hasTestCampaign
      : selectedTestType === "pricing"
        ? exp.testTypes.hasTestPricing
        : selectedTestType === "shipping"
          ? exp.testTypes.hasTestShipping
          : exp.testTypes.hasTestContent
  );
};

export const previewModeLink = (
  experienceTestList: ExperienceListDto[],
  campaigns: ExperienceListDto[],
  selectedTestType: ExperienceTestType,
  domain: string
): boolean | string => {
  const canPreview = !isSelectedTestTypeNotCreated(
    experienceTestList,
    campaigns,
    selectedTestType
  );

  if (canPreview) {
    if (selectedTestType === "campaign") {
      const campaignExperiments = filterByTestType(
        experienceTestList,
        selectedTestType
      );
      let newestCampaignExperiment: ExperienceDto | undefined = undefined;
      let newestCampaign: ExperienceDto | undefined = undefined;
      if (campaignExperiments.length > 0) {
        newestCampaignExperiment = campaignExperiments.reduce(
          (min: ExperienceDto, experiment: ExperienceDto) =>
            experiment.createdAtTs! > min.createdAtTs! ? experiment : min,
          campaignExperiments[0]
        );
      }
      if (campaigns.length > 0) {
        newestCampaign = campaigns.reduce(
          (min: ExperienceDto, campaign: ExperienceDto) =>
            campaign.createdAtTs! > min.createdAtTs! ? campaign : min,
          campaigns[0]
        );
      }

      if (newestCampaignExperiment && newestCampaign) {
        return `${domain}/?ig-preview=${
          newestCampaign.createdAtTs >
          (newestCampaignExperiment?.createdAtTs || 0)
            ? newestCampaign.id
            : newestCampaignExperiment.id
        }`;
      } else if (newestCampaignExperiment) {
        return `${domain}/?ig-preview=${newestCampaignExperiment.id}`;
      } else if (newestCampaign) {
        return `${domain}/?ig-preview=${newestCampaign.id}`;
      } else return false;
    } else {
      const eligibleExperiments = filterByTestType(
        experienceTestList,
        selectedTestType
      );
      if (eligibleExperiments.length > 0) {
        const newestExperiment = eligibleExperiments.reduce(
          (min: ExperienceDto, experiment: ExperienceDto) =>
            experiment.createdAtTs! > min.createdAtTs! ? experiment : min,
          eligibleExperiments[0]
        );
        if (newestExperiment) {
          return `${domain}/?ig-preview=${newestExperiment.id}`;
        } else return false;
      } else return false;
    }
  } else return false;
};
